import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getScheduledOrderCalendarRecords = async ({
  phoneNumber,
  startDate,
  endDate,
}: {
  phoneNumber: string;
  startDate: string;
  endDate: string;
}) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      phoneNumber,
      startDate,
      endDate,
    },
    query: graphql(`
      query GetScheduledOrderCalendarRecords($phoneNumber: String!, $startDate: String!, $endDate: String!) {
        getScheduledOrderCalendarRecords(phoneNumber: $phoneNumber, startDate: $startDate, endDate: $endDate) {
          id
          day0
          day1
          day2
          day3
          day4
          day5
          day6
          deliveryDate
          deliveryTime
          endAfterXTimes
          endOn
          endOnType
          isRepeated
          dateTimes
          minutesToAutoRetryRequest
          minutesBeforeCustomReminder
          skipDates
          completedAt
          canceledAt
          deliveryOrderId
          storeName
        }
      }
    `),
  });

  return response.data.getScheduledOrderCalendarRecords;
};
